export default function extractInitials (value, max = 2) {
  return `${value}`
    .replace(/[/\\-_.]+/g, '')
    .split(' ')
    .map(w => w.substr(0, 1))
    .splice(0, max)
    .join('')
}
